<template>
	<mdb-row class="mt-4 bindings-page">
		<template v-if="bindingsEditMode">
			<edit-table ref="table" class="my-1 mr-2 bindings-table" header-color="bg-default" :header-white="true" :columns="columns" :data="data" :current-page="page" @page="changePage" @delete="deleteBinding" @update="saveBinding">
				<template v-slot:__path="{ field, row, index, value }">
					<path-input :value="value" @change="change({ field, row, index, value: $event })"></path-input>
				</template>
				<template v-slot:post-table>
					<mdb-row class="mt-2 mb-2">
						<mdb-col>
							<mdb-btn @click="commit">{{ $t('bindings.commit', locale) }}</mdb-btn>
						</mdb-col>
						<mdb-col>
							<mdb-btn @click="rollback">{{ $t('bindings.rollback', locale) }}</mdb-btn>
						</mdb-col>
					</mdb-row>
				</template>
			</edit-table>
		</template>
		<template v-else>
			<mdb-col>
				<tbl striped bordered class="bg-white w-100">
					<tbl-head class="bg-default white-text">
						<tr>
							<th class="py-1">{{ $t('bindings.address-label', locale) }}</th>
							<th class="py-1">{{ $t('bindings.path-label', locale) }}</th>
						</tr>
					</tbl-head>
					<tbl-body>
						<tr v-for="binding in data" :key="binding.id">
							<td>{{ binding.address }}</td>
							<td>{{ displayPath(binding.path) }}</td>
						</tr>
						<tr v-if="!data.length">
							<td colspan="2">{{ $t('bindings.empty', locale) }}</td>
						</tr>
					</tbl-body>
				</tbl>
				<mdb-row class="mt-2 mb-2">
					<mdb-col>
						<mdb-btn @click="startEdit">{{ $t('bindings.edit', locale) }}</mdb-btn>
					</mdb-col>
				</mdb-row>
			</mdb-col>
		</template>
	</mdb-row>
</template>

<script>
import { mdbBtn, Tbl, TblBody, TblHead } from '@/components/mdbvue'
import { mapState, mapGetters, mapActions } from 'vuex'

import EditTable from '@/components/common/EditTable'
import PathInput from '@/components/common/PathInput'

export default {
	name: 'Bindings',
	components: { EditTable, PathInput, mdbBtn, Tbl, TblBody, TblHead },
	data () {
		return {
			page: 0
		}
	},
	async created () {
		await this.syncToRoute(this.$route)
	},
	async beforeRouteLeave (to) {
		const stayingOnBindings = to.name === 'BindingsIndex' || to.name === 'BindingsEdit'
		if (this.bindingsEditMode && !stayingOnBindings) {
			await this.rollbackBindingTransaction()
		}
	},
	computed: {
		columns () {
			return [
				{
					label: this.$t('bindings.address-label', this.locale),
					field: 'address',
					sort: 'asc'
				},
				{
					label: this.$t('bindings.path-label', this.locale),
					field: 'path'
				}
			]
		},
		data () {
			return Object.values(this.bindings)
		},
		...mapState(['locale']),
		...mapState('bindings', ['bindings']),
		...mapGetters('bindings', ['bindingsEditMode', 'newBinding'])
	},
	watch: {
		async $route (to) {
			await this.syncToRoute(to)
		}
	},
	methods: {
		displayPath (path) {
			return (path === 'tx' || !path) ? '' : String(path).replace(/^tx\./, '')
		},
		change ({ field, row, index, value }) {
			this.$refs.table.change({ field, row, index, value })
		},
		changePage (page) {
			this.page = page
		},
		async saveBinding (binding) {
			await this.updateBinding(Object.assign({}, this.newBinding, binding))
		},
		async syncToRoute (route) {
			if (route.name === 'BindingsEdit') {
				if (!this.bindingsEditMode) {
					await this.beginBindingTransaction()
				}
			} else if (this.bindingsEditMode) {
				await this.rollbackBindingTransaction()
			} else {
				await this.fetchBindings()
			}
		},
		async startEdit () {
			await this.beginBindingTransaction()
			await this.$router.push({ name: 'BindingsEdit' })
		},
		async commit () {
			await this.commitBindingTransaction()
			await this.$router.push({ name: 'BindingsIndex' })
		},
		async rollback () {
			await this.rollbackBindingTransaction()
			await this.$router.push({ name: 'BindingsIndex' })
		},
		...mapActions('bindings', ['fetchBindings', 'updateBinding', 'deleteBinding', 'beginBindingTransaction', 'commitBindingTransaction', 'rollbackBindingTransaction'])
	}
}
</script>

<style scoped>
.bindings-table {
	margin-top: 0;
}
.bindings-page >>> thead th {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}
>>> input.form-control {
	margin-bottom: 0;
}
</style>
